import { createSlice, PayloadAction, ValidateSliceCaseReducers } from '@reduxjs/toolkit';
import { TreeNodeWithMetadataType } from '../components/directory-tree-wrapper';
import { CustomerType, SharingDocumentType } from '../types/types';

export interface SharingDocumentStateProps {
    selectedTreeKey: string[];
    allTreeKeys: string[];
    documentTree: TreeNodeWithMetadataType[];
    listDocument: SharingDocumentType[];
    listCustomer: CustomerType[];
    openDocument: SharingDocumentType | null;
}

const initialState: SharingDocumentStateProps = {
    selectedTreeKey: [],
    allTreeKeys: [],
    documentTree: [],
    listDocument: [],
    listCustomer: [],
    openDocument: null
};

export type SetterSharingDocumentParams = Partial<SharingDocumentStateProps>;

const sharingDocumentReducers: ValidateSliceCaseReducers<
    SharingDocumentStateProps,
    {
        setterSharingDocument: {
            reducer: (
                state: SharingDocumentStateProps,
                action: PayloadAction<SetterSharingDocumentParams>,
            ) => void | SharingDocumentStateProps;
            prepare: (payload: SetterSharingDocumentParams) => { payload: SetterSharingDocumentParams };
        };
    }
> = {
    setterSharingDocument: {
        reducer: (state, action) => {
            // Эта логика остается неизменной
            return { ...state, ...action.payload };
        },
        prepare: (payload) => {
            return { payload };
        },
    },
};

export const sharingDocumentSlice = createSlice({
    name: 'drawings',
    initialState,
    reducers: sharingDocumentReducers,
    extraReducers: () => {},
});

export const {
    setterSharingDocument,
} = sharingDocumentSlice.actions;

export const sharingDocumentSliceReducer = sharingDocumentSlice.reducer;
